<template>
   <div class="content">
     <div class="header">
       <span class="h_back" @click="back"></span>
       <span class="h_title">{{detail.tourDetailInfo&&detail.tourDetailInfo.name}}</span>
     </div>
     <div class="mycont">
       <div class="swiper-container slide-wrap-exhibition1">
         <div class="swiper-wrapper">
           <div class="swiper-slide">
             <div class="slide-item" >
               <img :src="detail.picList&&detail.picList[0].pictureUrl" alt="">
               <div class="mymask">
                 <p>{{detail.tourDetailInfo&&detail.tourDetailInfo.collectionNum}}件藏品</p>
                 <p @click="gototheme(detail.tourDetailInfo.id)">查看全部</p>
               </div>
             </div>
           </div>
         </div>
         <div class="swiper-pagination"></div>
       </div>

     </div>
     <div class="contBottom">
       <div class="tab" @click="toggleTab('Tabdetail')" :class="tabValue== 'Tabdetail'? 'active' : '' "><span>详情</span></div>
       <div class="tab" @click="toggleTab('Tabspeaker')" :class="tabValue== 'Tabdetail'? '' : 'active' "><span>讲解</span></div>
       <mytab :is="tabValue" keep-alive :Mydata="detail"></mytab>
     </div>
   </div>
</template>

<script>
  import {api} from '../global/api';
  import Tabdetail from '@/view/tabdetail'
  import Tabspeaker from '@/view/tabspeaker'
  import Swiper from 'swiper';
  import 'swiper/dist/css/swiper.min.css';
    export default {
        name: "detail",
      data(){
        return {
          maskShow:false,
          tabValue:'Tabdetail',
           id:"",
          detail:{},
         defaultImg: this.$store.getters.defaultImg,
        }
      },
      components: {
        Tabdetail,
        Tabspeaker
      },
      mounted() {
        this.id=this.$route.query.id;
        this.getdata();
        var that=this;
      },
      methods: {
        back(){
          this.$router.go(-1);
        },
          getdata(){
            var that=this;
            this.$http.get(api.guidedetail+"?id="+that.id).then((res)=>{
              if(res.data.success==1){
                that.detail=res.data.data;
                that.$nextTick(()=>{
                  var swiper = new Swiper('.slide-wrap-exhibition1', {
                    grabCursor: true,
                    centeredSlides: true,
                    slidesPerView: 'auto',
                    observer:true,//修改swiper自己或子元素时，自动初始化swiper
                    observeParents:true,//修改swiper的父元素时，自动初始化swiper
                    pagination : '.swiper-pagination',
                    /*onReachEnd: function(swiper){
                      that.maskShow=true;
                    }*/
                  });
                })
              }
            })
          },
        toggleTab: function(tab) {
          this.tabValue=tab;
        },
        gototheme(num){
          this.$router.push({path:'/ThemeList',query:{"id":num}});
        }
      }
    }
</script>

<style  lang="less">
  .header{
    width:100%;
    height: 2.25rem;
    background-color: rgba(196, 77, 65, 1);
    position: fixed;
    top: 0;
    z-index: 100;
  }
  .header span{
    display: block;
  }
  .h_title{
    height:  2.25rem;
    line-height:  2.25rem;
    color: rgba(255, 255, 255, 1);
    font-size: 0.8rem;
    text-align: center;
    font-family: PingFang-SC-Bold;
    width: 9rem;
    margin: 0 auto;
  }
  .h_back{
    background: url("../../static/images/cp_backbtn.svg") center no-repeat;
    background-size: 100% 100%;
    width: .55rem;
    height: 1rem;
    position: absolute;
    left: .75rem;
    top: 0;
    bottom: 0;
    margin: auto;
  }
  .mycont{
    margin-top: 2.25rem;
    padding-top: 1rem;
  }
 .slide-wrap-exhibition1{
   width: 17.25rem;
   margin: 0 auto 1rem;
   height:12.9rem;
   border-radius:0.5rem;
   .swiper-pagination{
     bottom: 1.6rem;
     right: 1.25rem;
     text-align: right;
     width: 6rem;
     left: auto;
     .swiper-pagination-bullet{
       width:0.2rem;
       height:0.2rem;
       background:rgba(216,216,216,1);
     }
     .swiper-pagination-bullet-active{
       width:0.75rem;
       height:0.2rem;
       background:linear-gradient(54deg,rgba(128,226,255,1) 0%,rgba(72,165,255,1) 100%);
       border-radius:0.1rem;
     }
   }
   .slide-item{
     position: relative;
     img{
       width:17.25rem;
       height:12.9rem;
       border-radius:0.5rem;
     }
     .slide-content{
       position: absolute;
       bottom: 1.6rem;
       left: 1.25rem;
       p{
         height:0.9rem;
         font-size:0.65rem;
         font-family:PingFangSC-Regular;
         font-weight:400;
         color:rgba(255,255,255,1);
         line-height:0.9rem;
       }
     }
   }

 }
</style>
<style lang="less">
  .content{
    .mymask{
      position: absolute;
      width: 100%;
      height: 14.05rem;
      background:rgba(0,0,0,0.5);
      padding: 4.45rem 0 5.2rem;
      top: 0;
      left: 0;
      z-index: 2;
      text-align: center;
      p:nth-child(1){
        width:5.25rem;
        height:1.8rem;
        margin: 0 auto;
        font-size:1.25rem;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(255,255,255,1);
        line-height:1.8rem;
      }
      p:nth-child(2){
        width:5.4rem;
        height:2rem;
        margin: .6rem auto 0;
        border-radius:1rem;
        border:0.1rem solid;
        font-size:0.85rem;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(255,255,255,1);
        line-height:2rem;
      }
    }
    .contBottom{
      padding-bottom: 2.45rem;
      width: 100%;
      background:rgba(255,255,255,1);
      border-top-right-radius: .75rem;
      border-top-left-radius: .75rem;
      position: absolute;
      z-index: 9;
      .tab{
        float: left;
        width: 50%;
        margin-bottom: .95rem;
        &.active{
          span{
            color:rgba(196,77,65,1);
            border-bottom: 2px solid rgba(196,77,65,1);

          }
        }
        span{
          width:1.3rem;
          height:0.1rem;
          display: block;
          font-size:0.65rem;
          font-family:PingFangSC-Regular;
          font-weight:400;
          text-align: center;
          padding-bottom: 1rem;
          margin:0 auto;
          color:rgba(153,153,153,1);
          line-height:0.9rem;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/guideDetail.vue